import { useCallback, useEffect, useState } from 'react';
import { loadEarnings, loadNews, loadWatchlist } from './market';
import type { EarningsResponse, NewsResponse, StockSymbol, WatchlistResponse } from './types';
export function useStockMarket(){const[data,setData]=useState<WatchlistResponse|null>(null);const[loading,setLoading]=useState(true);const[refreshing,setRefreshing]=useState(false);const[error,setError]=useState<string|null>(null);const refresh=useCallback(async()=>{setRefreshing(true);setError(null);try{setData(await loadWatchlist());}catch(err){if((err as{status?:number}).status===401){window.location.assign('/login');return;}setError('Die Aktienkurse sind momentan nicht erreichbar. Bitte versuchen Sie es erneut.');}finally{setLoading(false);setRefreshing(false);}},[]);useEffect(()=>{void refresh();},[refresh]);return{data,loading,refreshing,error,refresh};}

export function useStockDetails(symbol: StockSymbol) {
  const [news, setNews] = useState<NewsResponse | null>(null);
  const [earnings, setEarnings] = useState<EarningsResponse | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let active = true;
    setLoading(true);
    setError(null);
    Promise.all([loadNews(symbol), loadEarnings(symbol)])
      .then(([newsResult, earningsResult]) => {
        if (!active) return;
        setNews(newsResult);
        setEarnings(earningsResult);
      })
      .catch((err: { status?: number }) => {
        if (!active) return;
        if (err.status === 401) {
          window.location.assign('/login');
          return;
        }
        setError('Details für diese Aktie sind momentan nicht erreichbar.');
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => {
      active = false;
    };
  }, [symbol]);

  return { news, earnings, loading, error };
}
